export function getMaximumCertificateExpirationDate(referenceDate = new Date()): string {
    const year = referenceDate.getFullYear() + 5;
    const month = referenceDate.getMonth() + 1;
    const lastDay = new Date(year, month, 0).getDate();

    return `${year}-${String(month).padStart(2, "0")}-${String(lastDay).padStart(2, "0")}`;
}
